<template>
  <div class="empty-state">
    <svg class="empty-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="30" stroke="#E5E7EB" stroke-width="2"/>
      <path d="M32 20V32M32 44H32.02" stroke="#9CA3AF" stroke-width="3" stroke-linecap="round"/>
    </svg>
    <p class="empty-message">{{ message }}</p>
    <p v-if="description" class="empty-description">{{ description }}</p>
    <slot name="action"></slot>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    message: {
      type: String,
      default: 'No data available'
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;

  .empty-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
    opacity: 0.5;
  }

  .empty-message {
    font-size: 16px;
    color: #606266;
    margin: 0 0 8px 0;
    font-weight: 500;
  }

  .empty-description {
    font-size: 14px;
    color: #909399;
    margin: 0 0 20px 0;
    max-width: 400px;
  }
}
</style>
